(function($, Drupal, drupalSettings) {

  Drupal.behaviors.get_in_touch_dt = {
    attach: function (context, settings) {

      var webform = $('.webform-submission-get-in-touch-dt-form');

      /**
      * Inject the progress div and buttons.
      */
      if (webform.length) {
        var navButtons = $('.nav-buttons', context);
        navButtons.once('inject-progress').before('<div class="get-in-touch-dt-progress"><div></div></div>');
        navButtons.once('inject-next-prev').prepend('<div class="get-in-touch-dt-buttons"><div class="back disabled"></div><div class="forward disabled"></div></div>');
        // Set initial progress bar.
        progress_animate('1');
      }


      /**
      * Set contact panel notes to first section description (if exisits).
      */
      var contactPanelNotes = $('.nav-003-contact-panel-notes');
      if (webform.length && contactPanelNotes.length) {
        webform.find('section:first-of-type .description').once('inject-notes').replaceWith('<div class="description contact-panel-notes">' + contactPanelNotes.html() + '</div>');
        contactPanelNotes.remove();
      }

      /**
      * Animate the progress div.
      */
      function progress_animate(section) {
        section = section.substr(section.length - 1);
        numberOfSections = $('.webform-submission-get-in-touch-dt-form section').length;
        (isNaN(section)) ? percentageProgress = 100 : percentageProgress = (section / numberOfSections) * 100;
        $('.get-in-touch-dt-progress > div').css('width', percentageProgress + '%');
      }

      /**
      * Set up and push progress data to local storage.
      */

      // Reset progress storage.
      localStorage.removeItem('progress');

      function save_progress(data) {

        var array = [];

        array = JSON.parse(localStorage.getItem('progress')) || [];
        array.push(data);
        localStorage.setItem('progress', JSON.stringify(array));

      }

      // Save intial value.
      var section = webform.find('section').first().attr('id');
      var question = webform.find('.form-radios').first().attr('id');
      save_progress(section +'_'+ question +'_'+ '1');

      /**
      * Fade in and fade out the section, answer/question.
      */
      function hide_show(animation, data) {

        var dataResult = '';
        var dataIndex = '';
        var dataSection = '#' + data[0];
        var current = data[0] +'_'+ data[1] +'_'+ data[2];
        var ie = $('body').hasClass('browser-ie');

        (data[0] == 'edit-answer-section') ? dataIndex = $('section').length : dataIndex = data[2];

        // Update data-current-x.
        $('.get-in-touch-dt-buttons')
          .attr('data-current', current)
          .attr('data-current-index', dataIndex);

        (data[0] == 'edit-answer-section') ? dataResult = '#' + data[1] +'-'+ data[2] : dataResult = '#' + data[1] + '--wrapper';

        if (animation == 'show') {
          (!ie) ? $(dataSection +', '+ dataResult).fadeIn() : $(dataSection +', '+ dataResult).show();
        }
        else if (animation == 'hide') {
          (!ie) ? $(dataSection +', '+ dataResult).fadeOut() : $(dataSection +', '+ dataResult).hide();
        }

        // Trigger nicescroll.
        $('.contact-panel').getNiceScroll().resize();

        // Update progress.
        progress_animate(data[0]);

        // Enable back button.
        enable_back_button();

        // Enable forward button.
        // Timeout is require to make sure data has loaded.
        setTimeout(function() { enable_forward_button(current, dataIndex); }, 10);

      }

      /**
      * Back and forward.
      */
      function back_forward(direction, current) {

        // Fade out current section and answer/question.
        hide_show('hide', current.split('_'));

        // Fade in section, saved in local storage.
        var progress = JSON.parse(localStorage.getItem('progress'));

        $.each(progress, function(index, value) {
          if (value == current) {
            if (direction == 'back') {
              hide_show('show', progress[index - 1].split('_'));
            }
            else if (direction == 'forward') {
              hide_show('show', progress[index + 1].split('_'));
            }
          }
        });

      }

      /**
      * Update progress local storage.
      */
      function update_progress(current) {

        var progress = JSON.parse(localStorage.getItem('progress'));

        $.each(progress, function(index, value) {
          // Filter to current progress.
          if (value == current) {

            var progressData = progress[index].split('_');
            var currentIndex = progressData[2];
            var previousProgressData = progress[index - 1].split('_');
            var previousIndex = previousProgressData[2];

            // Section is before current.
            if (currentIndex <= previousIndex) {
              // Splice from currrent.
              progress.splice((currentIndex - 1), (progress.length - currentIndex));
            }

          }
          // Set updated progress to local storage.
          localStorage.setItem('progress', JSON.stringify(progress));
        });

      }

      /**
      * Enable the back button.
      */
      function enable_back_button() {

        var buttons = $('.get-in-touch-dt-buttons');
        var dataCurrentIndex = buttons.attr('data-current-index');
        var back = buttons.find('.back');

        (dataCurrentIndex != 1) ? back.removeClass('disabled') : back.addClass('disabled');

      }

      /**
      * Enable the forward button.
      */
      function enable_forward_button(current, currentIndex) {

        var forward = $('.get-in-touch-dt-buttons').find('.forward');
        var progress = JSON.parse(localStorage.getItem('progress'));

        $.each(progress, function(index, value) {
          if (current == value) {
            if ((typeof progress[index + 1] === 'undefined') || (currentIndex == 6)) {
              forward.addClass('disabled');
            } else {
              forward.removeClass('disabled');
            }
          }
        });

      }

      /**
      * Radio click.
      */
      $('.webform-submission-get-in-touch-dt-add-form .form-type-radio label', context).once('radio-click').on('click', function() {

        var $this = $(this).parent();
        var $thisValue = $this.find('input').val();
        var $thisValueData = $thisValue.split('_');

        // Fade out current section.
        $this.closest('section').fadeOut();

        // Fade in section and answer/question.
        hide_show('show', $thisValueData);

        // Save progress data.
        save_progress($thisValueData[0] +'_'+ $thisValueData[1] +'_'+ $thisValueData[2]);

        // Update progress if you are before current.
        var current = $('.get-in-touch-dt-buttons').attr('data-current');
        update_progress(current);

      });

      /**
      * Back button click.
      */
      $('.get-in-touch-dt-buttons .back', context).once('back-click').on('click', function() {

        var direction = 'back';
        var buttons = $(this).parent();
        var current = buttons.attr('data-current');

        back_forward(direction, current);

      });

      /**
      * Forward button click.
      */
      $('.get-in-touch-dt-buttons .forward', context).once('forward-click').on('click', function() {

        var direction = 'forward';
        var buttons = $(this).parent();
        var current = buttons.attr('data-current');

        back_forward(direction, current);

      });

      /**
      * Set section height.
      */
      if (webform.length) {
        $('.contact-cta', context).once('section-heights').on('click', function() {
          setTimeout(function() {
            var panelHeight = $('.contact-panel').height();
            var titleHeight = $('.contact-panel-title').outerHeight(true);
            if (!$('body').hasClass('browser-ie')) {
              webform.find('section').height(panelHeight - titleHeight);
            } else {
              webform.find('section').height(panelHeight - titleHeight - 40);
            }
          }, 10);
        });
      }

    }
  }; // Drupal.behaviors.get_in_touch_dt

})(jQuery, Drupal, drupalSettings);
